module.exports = __webpack_public_path__ + "img/home-special-offter-01.ae4feb61.jpg";